// import { GlobalConfig } from '../config'
import { URLQueries } from './url_query'
import { is } from '@didi/webx-js'
/**
 * 获取 openid
 * @param {Object} options - 选项
 * @param {boolean} [options.redirectWhenFailed = true] - 失败时是否自动跳转到 OpenId 获取页面
 */
export const getOpenId = ({ redirectWhenFailed = true } = {}) => {
  if (
    __mpx_mode__ === 'web' &&
    !is('miniprogram') &&
    (is('mqq') || is('alipay') || is('weixin'))
  ) {
    const openid =
      URLQueries.getQuery('openid') ||
      URLQueries.getQuery('open_id') ||
      URLQueries.getQuery('openId')
    if (openid) {
      return openid
    } else if (redirectWhenFailed) {
      // window.location.href = `${
      //   GlobalConfig.OIDPath
      // }?redirect=${encodeURIComponent(
      //   encodeURIComponent(encodeURIComponent(window.location.href))
      // )}`
      return ''
    } else {
      return ''
    }
  } else if (is('miniprogram')) {
    return (
      URLQueries.getQuery('openid') ||
      URLQueries.getQuery('open_id') ||
      URLQueries.getQuery('openId')
    )
  } else {
    return ''
  }
}
